( function () {
	'use strict';

	// remove when angular issue has been resolved
	// https://github.com/angular/angular.js/issues/5858
	function isolateForm () {
		function formLink ( scope, elm, attrs, ctrl ) {
			if ( !ctrl ) {
				return;
			}

			// Do a copy of the controller
			var ctrlCopy = { };

			angular.copy( ctrl, ctrlCopy );

			// Get the parent of the form
			var parent = elm.parent().controller( 'form' );

			// Remove parent link to the controller
			parent.$removeControl( ctrl );

			function setValidity ( validationToken, isValid, control ) {
				ctrlCopy.$setValidity( validationToken, isValid, control );
				parent.$setValidity( validationToken, true, ctrl );
			}

			function setDirty () {
				elm.removeClass( 'ng-pristine' ).addClass( 'ng-dirty' );
				ctrl.$dirty    = true;
				ctrl.$pristine = false;
			}

			// Replace form controller with a "isolated form"
			var isolatedFormCtrl = {
				'$setValidity' : setValidity,
				'$setDirty'    : setDirty
			};

			angular.extend( ctrl, isolatedFormCtrl );
		}

		return {
			'restrict' : 'A',
			'require'  : '?form',
			'link'     : formLink
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'isolateForm', isolateForm );
} )( );
